<template>
  <div>
    <div class="Header">
      <Header :ismenu="false"></Header>
    </div>
    <div class="header_box"></div>
    <!-- 移动端 -->
    <div class="module module_reg">
      <div class="wrap">
        <div class="reg_height"></div>
        <div class="reg_box">
          <div class="reg_header">欢迎您来到 2026 年工博会</div>
          <div class="reg_content">
            <div class="reg-c-1">
              <div class="reg-one">
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_1.png" alt="" />
                <span>方式1：微信二维码注册</span>
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/login/icon_like.png" alt="" />
              </div>
              <div class="reg-text1">
                *
                关注施耐德电气公众号，会议期间您可以参与积分互动和大转盘抽奖，有机会赢取精美好礼！
              </div>
              <div class="reg-center">
                <div class="center2">
                  <img class="QR_code" :src="qrcodeUrl" alt="" />
                </div>
                <div class="center3">
                  *您可使用微信扫描此二维码，直接访问<br />*您可截图保存此页，然后在微信中进行二维码扫描
                </div>
              </div>
            </div>
            <div class="reg-c-2">
              <div class="reg-two">
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_1.png" alt="" />
                <span>方式2：点击下方按钮进行注册</span>
              </div>
              <div class="reg-text1">
                *
                注册成功后，如需参与积分互动和抽奖，请您先关注施耐德电气公众号，按提示操作。
              </div>
              <div class="reg-reg">
                <span class="btn-register1" @click="goRegister">我要注册</span>
                <div class="btn-login1-box">
                  <p>我已注册，请点击此处</p>
                  <span class="btn-login1" @click="goLogin">登录</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";
import qrcodeData from "@/assets/json/qrcode.json";
import { GetUserLogs, ReadNotice } from "../../api/index.js";
let nowDate = new Date();
export default {
  data() {
    return {
      qrcodeData,
      qrcodeUrl:
        "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQE98TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyalRPdmRxa2Q4dFQxT1pmWjFDMVgAAgS9gtVmAwQAjScA",
      isIntegral: false,
      integralText: "",
      registerUrl: "https://events.schneider-electric.cn/new_edition/schneider/gongbohui/2026/toRegist.html",  // 注册url正式
      loginUrl: "https://events.schneider-electric.cn/new_edition/schneider/gongbohui/2026/toLogin.html",  // 登录url正式
      defaultTrack: 11058,  // 默认track值 1-1-1-2-1为测试  1-1-0-5-8为全局替换
    };
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-注册",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : this.defaultTrack,
    });
    setTimeout(() => {
      console.log(this.$route.query)
      console.log(this.$route.query.track)

      let track = this.$route.query.track ? this.$route.query.track : this.defaultTrack;
      console.log(track)
      let i = this.qrcodeData.findIndex((item) => item.track === Number(track));
      this.qrcodeUrl = this.qrcodeData[i].QR_code;
      console.log(this.qrcodeData[i].QR_code)

    }, 500);

    if (this.$store.state.islogin) {
      this.$router.go(-1);
    }
  },
  methods: {
    goRegister() {
      const obj = {
        event: "trk",
        ec: "pcregis",
        ea: "signup",
        el: "reigs",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      var params = this.$route.query;
      if (!params.track || params.track == "") {
        params.track = this.defaultTrack;
      }
      // 正式，注册
      var register = this.registerUrl;
      window.location.href =
        register +
        "?track=" +
        (params.track ? params.track : this.defaultTrack) +
        "&utm_source=" +
        (params.utm_source ? params.utm_source : "") +
        "&utm_medium=" +
        (params.utm_medium ? params.utm_medium : "") +
        "&utm_campaign=" +
        (params.utm_campaign ? params.utm_campaign : "") +
        "&utm_content=" +
        (params.utm_content ? params.utm_content : "") +
        "&se_sr=" +
        (params.se_sr ? params.se_sr : "") +
        "&se_md=" +
        (params.se_md ? params.se_md : "") +
        "&se_ct=" +
        (params.se_ct ? params.se_ct : "") +
        "&backlink=" +
        params.backlink;
    },
    goLogin() {
      const obj = {
        event: "trk",
        ec: "pcregis",
        ea: "login",
        el: "login",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      var params = this.$route.query;
      if (!params.track || params.track == "") {
        params.track = this.defaultTrack;
      }
      var login = this.loginUrl;
      window.location.href =
        login +
        "?track=" +
        (params.track ? params.track : this.defaultTrack) +
        "&utm_source=" +
        (params.utm_source ? params.utm_source : "") +
        "&utm_medium=" +
        (params.utm_medium ? params.utm_medium : "") +
        "&utm_campaign=" +
        (params.utm_campaign ? params.utm_campaign : "") +
        "&utm_content=" +
        (params.utm_content ? params.utm_content : "") +
        "&se_sr=" +
        (params.se_sr ? params.se_sr : "") +
        "&se_md=" +
        (params.se_md ? params.se_md : "") +
        "&se_ct=" +
        (params.se_ct ? params.se_ct : "") +
        "&backlink=" +
        params.backlink;
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>